import { useCallback, useEffect } from 'react';
import { useAuth as useOpenIDConnectAuth } from 'react-oidc-context';
import { AuthSubject, AuthSubjectEvent } from '../../state/AuthSubject';
import { OpenIDConnectStrategyCode } from './OpenIDConnectConstants';

export interface IOpenIDConnectEventHandlerProps {}

/**
 * Gestisce gli eventi dell'OpenID Connect, specialmente per il logout.
 */
export function OpenIDConnectEventHandler(
  props: IOpenIDConnectEventHandlerProps,
) {
  const oidcContext = useOpenIDConnectAuth();

  const handleEvent = useCallback(
    async (event: AuthSubjectEvent) => {
      if (
        event.type === 'logout' &&
        event.auth.strategy === OpenIDConnectStrategyCode
      ) {
        try {
          await oidcContext.removeUser();
          await oidcContext.signoutRedirect({
            id_token_hint: oidcContext.user?.id_token,
          });
        } catch (err) {
          console.error(`[OIDC] Impossibile completare il logout`, err);
        }
      }
    },
    [oidcContext],
  );

  useEffect(() => {
    const subscription = AuthSubject.subscribe(event => {
      handleEvent(event).catch(err => {
        console.error(`[OIDC] Errore durante la gestione dell'evento`, {
          event,
          err,
        });
      });
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [handleEvent]);

  return null;
}
